import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import { firestore } from '../firebase/config';
import { createOwnershipRecord } from '../utils';

/**
 * Update comic ownership status in Firebase
 */
export const updateComicOwnership = async (comic, gotIt, userEmail, seriesId = null, heroId = 0) => {
  const id = typeof comic === 'object' ? comic.id : comic;
  
  const docRef = doc(firestore, "users/" + userEmail + "/comics/" + id);
  
  if (gotIt) {
    const ownershipData = createOwnershipRecord(comic, seriesId, heroId);
    await setDoc(docRef, ownershipData);
  } else {
    await deleteDoc(docRef);
  }
  
  // Note: The modified date is tracked in createOwnershipRecord
  // and in the series/comics documents when comics are reloaded
};
